'use strict';

//Require Modules
var $ = require('jquery'),
  _ = require('underscore'),
  Backbone = require('backbone'),
  mediator = require('../../../js/mediator'),
  SearchBarView = require('./SearchBarView'),
  config = require('../../../js/config'),
  AutoCompleteView = require('../../Typeahead/views/AutoCompleteView'),
  Analytics = require('../../Analytics/Analytics'),
  breakpoints = require('../../../js/breakpoints'),
  $global = require('../../../js/globalElements');

var HeaderSearchView = Backbone.View.extend({
  events: {
    click: 'onGlobalClick',
    keyup: 'onKeyUp',
    'focus .js-search-input': 'onFocus',
    'submit form': 'onFormSubmit'
  },
  initialize: function() {
    this.searchInput = new SearchBarView({
      el: this.$el
    });
    this.$searchWrapper = $('.js-typeahead');

    //The views
    this.autoCompleteView = new AutoCompleteView({
      el: this.$searchWrapper.find('.js-search-autocomplete')[0]
    });
    $('.cat').on('focus', function() {
      $(this).parent().css('outline', '2px solid #7FC1EA');
    });

    $('.cat').on('blur', function() {
      $(this).parent().css('outline', '0px');
    });
    $('#HeaderTopBarDesktop').attr('tabindex','-1');

    //events
    $global.$body
      .on('keydown',_.bind(this.onSkipContent,this))
      .on('keyup', _.bind(this.onGlobalKeyUp, this))
      .on('click', _.bind(this.onGlobalClick, this));
    this.listenTo(this.searchInput, config.events.search.close, this.closeSearchHeader);
    this.listenTo(this.searchInput, config.events.search.closeAutoComplete, this.closeAutoComplete);
    this.listenTo(this.searchInput, config.events.search.makeSearch, this.onMakeSearch);
    this.listenTo(this.searchInput, config.events.search.makePastSearch, this.onMakePastSearch);
    this.listenTo(this.autoCompleteView, config.events.search.close, this.closeSearchHeader);
    mediator.on(config.events.ui.scroll, this.onScroll, this);
    mediator.on(config.events.header.openingDropdownView, this.onDropdownsOpening, this);
    mediator.on(config.events.megaMenu.open, this.closeSearchHeader, this);
    mediator.on(config.events.search.setIsVisible, this.setIsVisible, this);
    mediator.on(config.events.ui.resize, this.onResize, this);
  },
  show: function() {
    if (this.isVisible) return;
    mediator.trigger(config.events.header.openingDropdownView, this);
    this.isVisible = true;
    this.searchInput.onTypeaheadToggle();
    this.$searchWrapper.addClass(config.classes.isVisible);
    $global.$body.addClass(`${config.classes.hasHeaderDropdown} ${config.classes.isShowingTypeahead}`);
    mediator.set(config.state.header.typeaheadIsOpen, true);
  },
  closeAutoComplete: function() {

    this.isVisible = false;

    this.$searchWrapper.removeClass(config.classes.isVisible);
    this.autoCompleteView.hide();
    this.searchInput.onTypeaheadToggle();

    $global.$body.removeClass(`${config.classes.hasHeaderDropdown} ${config.classes.isShowingTypeahead} ${config.classes.isShowingAutoComplete}`);
    mediator.set(config.state.header.typeaheadIsOpen, false);
  },
  closeSearchHeader: function() {

    if (!this.isVisible) return;

    this.closeAutoComplete();

    this.searchInput.setPlaceholderText();
  },
  setIsVisible: function() {
    this.isVisible = true;
  },
  onDropdownsOpening: function(view) {
    if (view !== this) this.closeSearchHeader();
  },
  onGlobalKeyUp: function(e) {
    if (this.isVisible && e && e.keyCode && e.keyCode === config.key.escape) {
      this.closeSearchHeader();
    }
  },
  onGlobalClick: function(e) {
    let currentURL = window.location.href;
    if (currentURL.indexOf('#main-content') === -1) {
      let mainContentURL = currentURL + '#main-content';
      var links = document.getElementsByClassName('skip-link');
      for (var i = 0; i < links.length; i++) {
        $('.skip-link').eq(i).attr('href', mainContentURL);
      }
    }
    var $target = $(e.target);
    if ($target.closest('.Header-search,.TypeaheadAutocomplete').length && !$target.is('.cat')) {
      this.searchInput.$searchPlaceholder.addClass('is-hidden');
      e.stopPropagation();
    } else if (this.isVisible) {
      this.closeSearchHeader();
    }
  },
  onSkipContent: function(e) {
    const firstheaderBtn = document.querySelectorAll('#skip-link');
    const firstFocusable = firstheaderBtn[0];
    const nextheaderHref = document.querySelectorAll('#HeaderTopBarDesktop');
    const nextFocusableHref = nextheaderHref[0];
    const nextheaderBtn = document.querySelectorAll('#close-banner');
    const nextFocusable = nextheaderBtn[0];


    const isTabPressed = e.keyCode === 9; // isTabPressed
    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) /* shift + tab */ {
      if (document.activeElement === nextFocusable) {
        nextFocusableHref.focus();
        nextFocusableHref.tabIndex = 0;
        firstFocusable.tabIndex = -1;
        nextFocusable.tabIndex = -1;
        e.preventDefault();
      }
      else if (document.activeElement === nextFocusableHref) {
        firstFocusable.focus();
        firstFocusable.tabIndex = 0;
        nextFocusableHref.tabIndex = -1;
        e.preventDefault();
      }
    }

    else /* tab */ {
      if (document.activeElement === firstFocusable) {
        nextFocusableHref.focus();
        nextFocusableHref.tabIndex = 0;
        nextFocusable.tabIndex = 0;
        firstFocusable.tabIndex = -1;
        e.preventDefault();
      }
    }
  },
  onMakeSearch: function(searchValue, categoryValue) {
    mediator.trigger(config.events.search.typeaheadSearch, searchValue, categoryValue);
    this.show();
    $global.$body.addClass(config.classes.isShowingAutoComplete);
    //show and search with autocomplete view
    this.autoCompleteView.show();
  },
  onMakePastSearch: function() {
    this.show();
    $global.$body.addClass(config.classes.isShowingAutoComplete);
    //show and search with autocomplete view
    this.autoCompleteView.show();
  },
  onFormSubmit: function() {
    // Check to see if we have more than 1 letter in the search box
    if (!this.searchInput.lengthCheck()) {
      return false;
    }

    Analytics.setOnDataLayer({
      search: {
        advancedSearch: false
      }
    });

    Analytics.pushToEventFramework({
      event: config.analytics.events.formSubmission,
      category: config.analytics.categories.search,
      action: config.analytics.actions.searchBar,
      label: this.searchInput.searchValue
    });
  },
  onKeyUp: function(e) {
    var keyCode = e.keycode || e.which;

    if (keyCode === config.key.enter) {
      e.stopPropagation();

      this.selectedResult = this.$el.parents().find('.Typeahead li.TypeaheadAutocomplete-result.is-active a');
      if (this.selectedResult.length === 1) {
        window.location.href = this.selectedResult.attr('href');
      }
    }
    else if (this.isVisible && e && document.activeElement.className.indexOf('Search-bar-select-input') === -1 && e.keyCode && e.keyCode === config.key.tab)
    {
      this.closeSearchHeader();
    }
  },
  onScroll: function() {
    if (this.isVisible) this.closeSearchHeader();
  },
  onResize: function() {
    if (this.isVisible && window.innerWidth < config.breakpoints.laptop) {
      this.closeSearchHeader();
    }
  },
  onFocus: function(e) {
    e.stopPropagation();
    this._resetSearchViewOnSmallDevice();
  },
  _resetSearchViewOnSmallDevice: function() {
    const resetSearchView = breakpoints.isLessThan(config.breakpoint.tablet);
    if (resetSearchView) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
});

module.exports = HeaderSearchView;



// WEBPACK FOOTER //
// ./assets/components/Header/js/HeaderSearchView.js